import { Button, TooltipShortcut } from "@itk/mui-components";
import { Box, Stack, Tab, Tabs, useTheme } from "@mui/material";
import { DekoxIcon } from "src/components";
import { configuratorPageK, useConfiguratorPageT } from "src/translation-hooks/configurator-page";
import { TABS } from "../../configurator-utils";
import { TTabKey } from "../../configurator-types";
import { RootState } from "src/store";
import { connect } from "react-redux";
import { configuratorActions as configuratorActions } from "../../configurator-store";
import { useTranslation } from "react-i18next";
import { addEditConfigurationDialogActions } from "../add-edit-configuration-dialog/add-edit-configuration-dialog-store";

const mapStateToProps = (state: RootState) => ({
  activeTab: state.pageReducer.combinedConfiguratorReducer.configuratorReducer.activeTab
});

const ownActions = {
  setActiveTab: configuratorActions.setActiveTab,
  setAddEditConfigurationDialog: addEditConfigurationDialogActions.setAddEditConfigurationDialog
};

type Props = typeof ownActions & ReturnType<typeof mapStateToProps>;

const HeaderBase = (props: Props) => {
  const { activeTab, setActiveTab, setAddEditConfigurationDialog } = props;

  const theme = useTheme();
  const configuratorPageT = useConfiguratorPageT();
  const { t } = useTranslation();

  return (
    <Stack bgcolor={theme.palette.customColors.white} justifyContent="space-between" alignItems="stretch" direction="row" paddingX={4} borderBottom={`1px solid ${theme.palette.customColors.grey}`}>
      <Box sx={{ display: "flex", alignItems: "flex-end" }}>
        <Tabs value={activeTab} onChange={(_, value) => setActiveTab(value)} sx={{ "& .MuiTabs-indicator": { bottom: 11 } }}>
          {(Object.keys(TABS) as TTabKey[]).map(TAB => {
            return (
              <Tab key={TAB} value={TABS[TAB].value} label={t(TABS[TAB].label)} sx={{ color: theme.palette.primary.main, textTransform: "none", px: 1.5, py: 1, minHeight: 0, fontWeight: "normal" }} />
            );
          })}
        </Tabs>
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", py: 1 }}>
        <TooltipShortcut
          shortcut={{
            action: () => {
              setAddEditConfigurationDialog({ step: "SELECT SYSTEM" });
            },
            shortCutKey: "Insert"
          }}
        >
          <Button
            t={configuratorPageT}
            k={configuratorPageK}
            field="newConfiguration"
            variant="contained"
            startIcon={<DekoxIcon icon="add" />}
            onClick={() => {
              setAddEditConfigurationDialog({ step: "SELECT SYSTEM" });
            }}
          />
        </TooltipShortcut>
      </Box>
    </Stack>
  );
};

export const Header = connect(mapStateToProps, ownActions)(HeaderBase);
